import {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {Loading} from "../../../components/common/Loading";
import {alertAfterFunction, defaultAlert} from "../../../utils/alert";
import {getPaymentStatus, requestPaymentCancel} from "../../../services/payment/paymentService";
import {ChargeRequestLogTypes, ChargeRequestTypes} from "../../../types/transaction/transaction.types";
import {saveChargeData, updateChargeRequestLog} from "../../../api/transaction/chargeApi";

interface ChargeData {
    tid: string;
    reqChargeAmount: number;
    chargeFee: number;
    tranAmt: number;
}

//TODO: 충전결과 리턴 페이지 ( 실제 테스트 하면서 보완 필요) sessionStorage 사용 지양
export function ChargeCallback() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [chargeData, setChargeData] = useState<ChargeData>();


    const saveChargeRequest = async (paymentData: any, chargeData: ChargeData) => {
        // 충전 요청 페이지별 복귀 경로 (PaymentPage 잔액 부족 → 충전 흐름에서 세팅됨)
        const returnPath = sessionStorage.getItem('chargeReturnPath') || null;
        sessionStorage.removeItem('chargeReturnPath');

        try {
            const chargeRequest: ChargeRequestTypes = {
                chargeAmount: chargeData.reqChargeAmount,   // 충전 요청 금액
                chargeFee: chargeData.chargeFee,    // 충전 수수료
                paymentAmount: paymentData.amt || chargeData.tranAmt,   // pg 결제 금액
                paymentTransactionId: paymentData.tid,  // 결제거래ID
                paymentCompany: paymentData.van || 'BANKPAY'    // 결제회사
            };

            const response = await saveChargeData(chargeRequest);

            if (response.data.code === "00") {
                alertAfterFunction("충전이 완료되었습니다.", () => {
                    navigate(returnPath || '/wallet/charge-list');
                });
            } else {
                await chargeCancel(chargeData.tid || "", '충전 실패', "결제 에러");
            }

        } catch (error) {
            await chargeCancel(chargeData.tid || "", '충전 실패', "결제 에러");
            console.error('충전 요청 실패:', error);
        }
        // ※ finally에서 navigate('/wallet/charge')를 제거 —
        //   alertAfterFunction 콜백보다 먼저 실행되어 PaymentPasswordRoute가 가로채는 문제 방지
    };

    const checkPaymentResult = async (tid : string, chargeInfo: ChargeData) => {
        setIsLoading(true);

        if (!tid) {
            setIsLoading(false);
            defaultAlert("결제 도중 연결이 끊겼습니다.\n다시 시도해주세요.");
            return;
        }
        try {
            let success = false;
            for (let i = 0; i < 5; i++) {
                const response = await getPaymentStatus(tid || "");
                if (response.data.success) {
                    success = true;
                    await saveChargeRequest(response.data, chargeInfo);
                    setIsLoading(false);
                    break;
                }
                if (i < 4) {
                    await new Promise(resolve => setTimeout(resolve, 1000));
                }
            }
            if (!success) {
                await chargeCancel(tid, "결제 상태 확인에 실패했습니다.", "상태 확인 실패");
            }
        } catch (error) {
            console.error('결제 상태 조회 실패:', error);
            await chargeCancel(tid, "결제 상태 확인에 실패했습니다.", "상태 확인 실패");
        }

    };




    const checkPayment = async () => {
        const data: ChargeData = {
            tid: sessionStorage.getItem('tid') || "",
            reqChargeAmount: Number(sessionStorage.getItem("reqChargeAmount")),
            chargeFee: Number(sessionStorage.getItem("chargeFee")),
            tranAmt: Number(sessionStorage.getItem("tranAmt")),
        };

        setChargeData(data);

        const paymentDataRaw = searchParams.get('paymentData');

        if (!paymentDataRaw) {
            alertAfterFunction('결제 정보를 찾을 수 없습니다.', () => {
                    navigate('/charge');
                });
            return;
        }
        try {
            const paymentData = JSON.parse(decodeURIComponent(paymentDataRaw));
            const chargeRequestLog: ChargeRequestLogTypes = {
                chargeAmount: data.reqChargeAmount,
                chargeFee: data.chargeFee,
                tid: data.tid,
                payToken: '',
                paymentData: paymentData
            };
            await updateChargeRequestLog(chargeRequestLog);

            if (paymentData.success) {
                await checkPaymentResult(paymentData.tid, data);
            } else {
                setIsLoading(false);
                alertAfterFunction('결제에 실패했습니다.', () => {
                    navigate('/wallet/charge', { state: { reqChargeAmount: data.reqChargeAmount } });
                });
            }
        } catch (error) {
            console.error('결제 확인 오류:', error);
            //결제 실패 시 결제 취소 처리.
            await chargeCancel(data.tid || "", '결제 결과를 확인할 수 없습니다.', "결제 에러");
        } finally {
            sessionStorage.removeItem("tid");
            sessionStorage.removeItem("reqChargeAmount");
            sessionStorage.removeItem("chargeFee");
            sessionStorage.removeItem("tranAmt");
        }
    };

    const chargeCancel = async (tid: string, message: string, reason: string) => {
        try {
            await requestPaymentCancel(tid, reason);
            setIsLoading(false);
            alertAfterFunction('결제 실패', () => {
                navigate('/wallet/charge');
            });
        } catch (cancelError) {
            console.error('결제 취소 실패:', cancelError);
            setIsLoading(false);
            alertAfterFunction('결제 취소 실패', () => {
                navigate('/wallet/charge');
            });
        }
    }

    useEffect(() => {
        checkPayment();
    }, []);

  /*  useEffect(() => {
        window.history.replaceState(null, '', '/charge');
    }, []);*/

    return (
        <Loading
            loading={isLoading}
            onClose={() => {
                setIsLoading(false);
                navigate('/charge');
            }}
        />
    );
}